// extracted by mini-css-extract-plugin
export default {"editor":"CommentCreate-module__editor--Bm1B_","container":"CommentCreate-module__container--ciRXH","animatedBackground":"CommentCreate-module__animatedBackground--emn1f"};